export default __webpack_public_path__ + "static/love-your-muscles-cyclist-a3cf2bca6ae8d6ba141c3380695fc3be.jpg";